import { useState } from "react";
import { useAvtovazRequisites } from "~/entity/AvtovazRequisites";

export const useActivateRequisite = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isSuccess, setIsSuccess] = useState(false);
  const { activateAvtovazRequisite } = useAvtovazRequisites();

  const mutate = async (id: number) => {
    setIsLoading(true);
    setError(null);
    setIsSuccess(false);
    try {
      await activateAvtovazRequisite(id);
      setIsSuccess(true);
    } catch (error) {
      setError("Ошибка активации");
    } finally {
      setIsLoading(false);
    }
  };

  return { isLoading, error, mutate, isSuccess };
};
